// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.contacts.RentalManagerUserPropertyContactsWebApiHandler

import { frontEndRequestV2 } from '@zg-rentals/ts-client-fetch';
import type { RentalManagerEnvironment } from '@zg-rentals/rental-manager-env-base';

import type { GetContactCountForListingsRequestWebDto, UserPropertiesLeadCountDto } from '../..';

export const RentalManagerUserPropertyContactsWebApiHandler_getCountForListings_Path =
  '/api/web/v1/users/properties/contacts/getCountForListings';

/**
 * Get contact count for listings given a list of listing aliases
 */
export const RentalManagerUserPropertyContactsWebApiHandler_getCountForListings = (
  postData: GetContactCountForListingsRequestWebDto,
  environment?: RentalManagerEnvironment,
) => {
  return frontEndRequestV2<never, GetContactCountForListingsRequestWebDto, Array<UserPropertiesLeadCountDto>>({
    endpoint: RentalManagerUserPropertyContactsWebApiHandler_getCountForListings_Path,
    method: 'POST',
    contextPath: '/rental-manager-api',
    postData: postData,
    environment,
  });
};
